import { render, staticRenderFns } from "./ConfigCard.vue?vue&type=template&id=d495dc5c"
import script from "./ConfigCard.vue?vue&type=script&lang=js"
export * from "./ConfigCard.vue?vue&type=script&lang=js"
import style0 from "./ConfigCard.vue?vue&type=style&index=0&id=d495dc5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports